<template>
  <v-card>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <message :messages="messages"></message>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.scheme}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.schemeMenu.sideMenuTitle}}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{labels.planNo}}</v-subheader>
            <div class="title">{{this.$store.state.parameters.scheme.pkgPlanMenu.pkgPlanTitle}}</div>
          </v-flex>
          <v-flex xs6 v-if="newRisk">
            <v-text-field :label="labels.riskNo" v-model="pkgRiskForm.riskNo" :error-messages="errors.collect('riskNo')" v-validate="'required|numeric|max:10'" data-vv-name="riskNo" :data-vv-as="labels.riskNo"></v-text-field>
          </v-flex>
          <v-flex xs6 v-else>
            <v-subheader class="queryLabel">{{labels.riskNo}}</v-subheader>
            <div class="title">{{pkgRiskForm.riskNo}}</div>
          </v-flex>
          <v-flex xs6>
            <!-- space -->
          </v-flex>
          <v-flex xs6>
            <v-autocomplete :items="busClsList" v-model="pkgRiskForm.defBusCls" :label="labels.defBusCls" item-text="label" item-value="value" data-vv-name="defBusCls" :data-vv-as="labels.defBusCls" :error-messages="errors.collect('defBusCls')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-autocomplete :items="tariffList" v-model="pkgRiskForm.defTariff" :label="labels.defTariff" item-text="label" item-value="value" data-vv-name="defTariff" :data-vv-as="labels.defTariff" :error-messages="errors.collect('defTariff')" v-validate="'required'"></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-checkbox :label="labels.allowClmBefCvr" v-model="pkgRiskForm.allowClmBefCvr"></v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-flex xs12>
      <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSaveGeneral">
        {{ newRisk ? 'Save Risk' : 'Update Risk' }}
        <v-icon right>{{newRisk ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      labels: {
        scheme: 'Scheme',
        planNo: 'Package Plan',
        riskNo: 'Risk No*',
        defBusCls: 'Default Business Class*',
        defTariff: 'Default Tariff*',
        allowClmBefCvr: 'Allow Claim Before Coverage'
      },
      pkgRiskForm: {
        scheme: null,
        schemeDesc: null,
        planNo: null,
        planDesc: null,
        riskNo: null,
        defBusCls: null,
        defTariff: null,
        allowClmBefCvr: false
      },
      busClsList: [],
      tariffList: [],
      submitting: false,
      newRisk: false
    }
  },
  computed: {
    pkgPlanMenu() {
      return this.$store.state.parameters.scheme.pkgPlanMenu
    }
  },
  watch: {
    'ids.riskNo': function (value) {
      this.resetMessages()
      this.resetValidator()
      Promise.all([this.doBusClsList(), this.doTariffList()])
      if (value !== 'new') {
        this.newRisk = false
        if (value !== null) {
          this.fetchForm(value)
        }
      } else {
        this.newRisk = true
        this.doClearForm()
      }
    }
  },
  methods: {
    async fetchForm(riskNo) {
      if (!this.newRisk) {
        const apiURI = this.pkgPlanMenu.menu.pkgRisk
        if (apiURI) {
          try {
            const expand = {
              scheme: this.ids.scheme,
              planNo: this.ids.planNo,
              riskNo: riskNo
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.pkgRiskForm.scheme = data.pkgRisk.scheme
              this.pkgRiskForm.schemeDesc = data.pkgRisk.schemeDesc
              this.pkgRiskForm.planNo = data.pkgRisk.planNo
              this.pkgRiskForm.planDesc = data.pkgRisk.planDesc
              this.pkgRiskForm.riskNo = data.pkgRisk.riskNo
              this.pkgRiskForm.defBusCls = data.pkgRisk.defBusCls
              this.pkgRiskForm.defTariff = data.pkgRisk.defTariff
              this.pkgRiskForm.allowClmBefCvr = data.pkgRisk.allowClmBefCvr
              this.menu = extractMenu(result.data._links)
            } else {
              this.errorMessage('Fail to load Data from server. Please try to refresh page')
            }
          } catch (error) {
            const { data } = error.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('Invalid API Url - Package Risk Form')
        }
      }
    },
    async doSaveGeneral() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newRisk) {
            this.doCreateGeneral()
          } else {
            this.doUpdateGeneral()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateGeneral() {
      try {
        const apiURI = this.pkgPlanMenu.menu.pkgRiskCreate
        if (apiURI) {
          const formatForm = {
            scheme: this.pkgRiskForm.scheme,
            planNo: this.pkgRiskForm.planNo,
            riskNo: parseInt(this.pkgRiskForm.riskNo),
            defBusCls: this.pkgRiskForm.defBusCls,
            defTariff: this.pkgRiskForm.defTariff,
            allowClmBefCvr: this.pkgRiskForm.allowClmBefCvr
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('resetTab', 2)
          }
        }
      } catch (error) {
        const { data } = error.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    async doUpdateGeneral() {
      const apiURI = this.menu.pkgRiskUpdate
      if (apiURI) {
        try {
          const formatForm = {
            scheme: this.pkgRiskForm.scheme,
            planNo: this.pkgRiskForm.planNo,
            riskNo: parseInt(this.pkgRiskForm.riskNo),
            defBusCls: this.pkgRiskForm.defBusCls,
            defTariff: this.pkgRiskForm.defTariff,
            allowClmBefCvr: this.pkgRiskForm.allowClmBefCvr
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.fetchForm(this.ids.riskNo)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL - Package Risk Update')
      }
    },
    doClearForm() {
      this.resetValidator()
      this.resetMessages()
      this.pkgRiskForm.scheme = this.ids.scheme
      this.pkgRiskForm.schemeDesc = null
      this.pkgRiskForm.planNo = this.ids.planNo
      this.pkgRiskForm.planDesc = null
      this.pkgRiskForm.riskNo = null
      this.pkgRiskForm.defBusCls = null
      this.pkgRiskForm.defTariff = null
      this.pkgRiskForm.allowClmBefCvr = false
    },
    async doBusClsList() {
      const apiURI = this.pkgPlanMenu.menu.busClsList
      if (apiURI) {
        try {
          this.busClsList = []
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.busClsList = data.busClsList
          } else {
            this.busClsList = []
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.busClsList = []
        this.errorMessage('Invalid API URL - Business Class List')
      }
    },
    async doTariffList() {
      const apiURI = this.pkgPlanMenu.menu.tariffList
      if (apiURI) {
        try {
          this.tariffList = []
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.tariffList = data.tariffList
          } else {
            this.tariffList = []
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.tariffList = []
        this.errorMessage('Invalid API URL - Tariff List')
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    ids: {
      type: Object,
      default () {
        return {
          scheme: null,
          planNo: null,
          riskNo: null
        }
      }
    }
  }
}
</script>

<style>
</style>
